(function () {
  function pad(value) {
    return String(Math.max(0, value)).padStart(2, '0');
  }

  function animateChange(element, value) {
    if (!element || element.textContent === value) return;

    element.textContent = value;
    element.classList.remove('is-ticking');
    void element.offsetWidth;
    element.classList.add('is-ticking');
  }

  function startCountdown(countdown) {
    var targetValue = countdown.getAttribute('data-countdown-target');
    var target = Date.parse(targetValue);
    var liveStatus = countdown.parentElement.querySelector('[data-countdown-status]');
    var expiredText = countdown.getAttribute('data-expired-text') || 'Store opening now';

    if (Number.isNaN(target)) {
      countdown.textContent = expiredText;
      countdown.classList.add('is-complete');
      return;
    }

    var units = {
      days: countdown.querySelector('[data-countdown-days]'),
      daysLabel: countdown.querySelector('[data-countdown-days-label]'),
      hours: countdown.querySelector('[data-countdown-hours]'),
      minutes: countdown.querySelector('[data-countdown-minutes]'),
      seconds: countdown.querySelector('[data-countdown-seconds]')
    };

    var lastAnnouncedMinute = null;
    var intervalId;

    function update() {
      var remaining = Math.max(0, target - Date.now());

      if (remaining <= 0) {
        window.clearInterval(intervalId);
        countdown.textContent = expiredText;
        countdown.classList.add('is-complete');
        if (liveStatus) liveStatus.textContent = expiredText + '.';
        return;
      }

      var totalSeconds = Math.floor(remaining / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      animateChange(units.days, pad(days));
      if (units.daysLabel) units.daysLabel.textContent = days === 1 ? 'DAY' : 'DAYS';
      animateChange(units.hours, pad(hours));
      animateChange(units.minutes, pad(minutes));
      animateChange(units.seconds, pad(seconds));

      if (liveStatus && lastAnnouncedMinute !== totalSeconds - seconds) {
        lastAnnouncedMinute = totalSeconds - seconds;
        liveStatus.textContent =
          days +
          (days === 1 ? ' day, ' : ' days, ') +
          hours +
          ' hours, and ' +
          minutes +
          ' minutes until Australia tour tickets go on sale.';
      }
    }

    update();
    intervalId = window.setInterval(update, 1000);
  }

  function init() {
    document.querySelectorAll('[data-launch-countdown]').forEach(startCountdown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
